export default __webpack_public_path__ + "static/affiliate-program-Software-2@mob-20cdb21892dfbee0f2a4c7509c23b1b6.jpg";